import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import ClearIcon from "@mui/icons-material/Clear";
import { useFormik } from "formik";
import {
  useAddUserApiMutation,
  useEditUserMutation,
} from "../../services/users";
import { UploadMedia, Uploadpdf } from "../../utils/uploadMedia";
import { errorToast, successToast } from "../../helpers/toast";
import { useLazyGetSpecificAgentByIdQuery } from "../../services/agents";
import { CommonBody, Document } from "../../types/General";
import EditIcon from "@mui/icons-material/Edit";
import moment from "moment";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import Loader from "../../helpers/constants/Loader";
import {
  AGENCY_TYPE,
  AGENT_EMIRATE,
  DOCUMENT_TYPE,
  ROLE,
} from "../../constants/enums";

type DOC = {
  documentType_17: Number;
  documentNumber_17: Number | string;
  expiryDate_17: string;
  frontImage_17: string;
  backImage_17: string;

  documentType_19: Number;
  documentNumber_19: Number | string;
  frontImage_19: string;

  documentType_20: Number;
  documentNumber_20: Number | string;
  frontImage_20: string;

  BRN: Number | string;
  brn_expiryDate: string;
  brn_certificate: string;
  agentEmirate: number;
};
const AgentDocumentation = () => {
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [ByIdDetails, setByIdDetails] = useState<any>([]);
  const [editUSERbyId] = useEditUserMutation();
  const [addDocs] = useAddUserApiMutation();
  const [fetchApi] = useLazyGetSpecificAgentByIdQuery();

  const [documents, setDocuments] = useState<DOC>({
    documentType_17: DOCUMENT_TYPE.EMIRATES_ID,
    documentNumber_17: "",
    expiryDate_17: "",
    frontImage_17: "",
    backImage_17: "",

    documentType_19: DOCUMENT_TYPE.ADREC_OR_DARI_CARD,
    documentNumber_19: "",
    frontImage_19: "",

    documentType_20: DOCUMENT_TYPE.LABOUR_OR_EMPLOYMENT_VISA,
    documentNumber_20: "",
    frontImage_20: "",

    BRN: "",
    brn_expiryDate: "",
    brn_certificate: "",
    agentEmirate: 1,
  });
  console.log("documents :", documents);

  const handlePdfUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;
    if (!file) {
      return;
    }
    try {
      setIsLoading(true);
      const res = await Uploadpdf(file);
      setIsLoading(false);
      if (res?.statusCode === 200) {
        const imageUrl = res?.data[0]?.location;

        setDocuments({ ...documents, [type]: imageUrl });

        successToast("Document uploaded successfully.");
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.error("Error uploading docs:", error);
      errorToast("Error uploading docs. Please try again.");
    }
  };

  const fetchDataById = async (id: any) => {
    setIsLoading(true);
    try {
      const response = await fetchApi({ userId: id }).unwrap();
      if (response.statusCode === 200) {
        setIsLoading(false);
        let DOCS = response?.data?.documents;
        setDocuments((prev) => ({
          ...prev,
          agentEmirate: response?.data?.agentEmirate || 1,
          BRN: response?.data?.BRN,
        }));
        if (DOCS?.length) {
          DOCS.map((item: any) => {
            if (item?.documentType === DOCUMENT_TYPE.EMIRATES_ID) {
              setDocuments((prev) => ({
                ...prev,
                documentNumber_17: item?.documentNumber || "",
                expiryDate_17: item?.expiryDate
                  ? moment(item?.expiryDate).format("YYYY-MM-DD")
                  : "",
                frontImage_17: item?.frontImage || "",
                backImage_17: item?.backImage || "",
              }));
            } else if (
              item?.documentType === DOCUMENT_TYPE.LABOUR_OR_EMPLOYMENT_VISA
            ) {
              setDocuments((prev) => ({
                ...prev,
                documentNumber_20: item?.documentNumber || "",
                frontImage_20: item?.frontImage || "",
              }));
            } else if (
              item?.documentType === DOCUMENT_TYPE.ADREC_OR_DARI_CARD
            ) {
              setDocuments((prev) => ({
                ...prev,
                documentNumber_19: item?.documentNumber || "",
                frontImage_19: item?.frontImage || "",
              }));
            } else if (item?.isAdditionalDocument == false) {
              setDocuments((prev) => ({
                ...prev,
                brn_certificate: item?.frontImage || "",
                brn_expiryDate: item?.expiryDate
                  ? moment(item?.expiryDate).format("YYYY-MM-DD")
                  : "",
              }));
            }
          });
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const uploadDocumentsFun = async () => {
    let body = {
      profileSteps: 2,

      agentEmirate: documents.agentEmirate,
      isDocumentUploaded: true,
      documents: [
        {
          documentType: DOCUMENT_TYPE.EMIRATES_ID,
          documentNumber: documents.documentNumber_17,
          frontImage: documents.frontImage_17,
          backImage: documents.backImage_17,
          expiryDate: documents.expiryDate_17
            ? moment(documents.expiryDate_17)
                .utc()
                .format("YYYY-MM-DDTHH:mm:ss[Z]")
            : "",
        },
        ...(documents.agentEmirate == AGENT_EMIRATE.DUBAI_BASED
          ? [
              {
                BRN: documents.BRN,
                frontImage: documents.brn_certificate,
                expiryDate: documents.brn_expiryDate
                  ? moment(documents.brn_expiryDate)
                      .utc()
                      .format("YYYY-MM-DDTHH:mm:ss[Z]")
                  : "",
              },
            ]
          : []),
        // ...(documents.agentEmirate == AGENT_EMIRATE.ABU_DHABI
        //   ? [
        //       {
        //         documentType: DOCUMENT_TYPE.ADREC_OR_DARI_CARD,
        //         documentNumber: documents.documentNumber_19,
        //         frontImage: documents.frontImage_19,
        //       },
        //     ]
        //   : []),

        ...(documents.agentEmirate == AGENT_EMIRATE.OTHERS
          ? [
              {
                documentType: DOCUMENT_TYPE.LABOUR_OR_EMPLOYMENT_VISA,
                documentNumber: documents.documentNumber_20,
                frontImage: documents.frontImage_20,
              },
            ]
          : []),
      ],
    };
    console.log(body, "body");

    try {
      let encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await editUSERbyId({
        id,
        body: encryptedBody,
        isDocEdit: true,
      }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Agent documents updated successfully");
        navigate("/manage-agents");
      }
    } catch (error: any) {
      errorToast(
        error?.data?.message || error?.message || "Something went wrong"
      );
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  return (
    <div className="main_layout">
      <Loader isLoad={isLoading} />
      <div>
        <Grid
          item
          lg={6}
          md={6}
          sm={6}
          xs={12}
          style={{ marginBottom: "20px" }}
        >
          <Typography className="custom_label">
            Select Company Emirate{" "}
          </Typography>
          <Select
            className="select_div"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            name="agentEmirate"
            fullWidth
            value={documents.agentEmirate}
            onChange={(e) =>
              setDocuments({
                ...documents,
                agentEmirate: Number(e.target.value),
              })
            }
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select
            </MenuItem>
            <MenuItem value={AGENT_EMIRATE.DUBAI_BASED}>Dubai</MenuItem>
            <MenuItem value={AGENT_EMIRATE.ABU_DHABI}>Abu Dhabi</MenuItem>
            <MenuItem value={AGENT_EMIRATE.OTHERS}>Other</MenuItem>
          </Select>
        </Grid>

        <div style={{ marginTop: "20px" }} className="single_doc">
          <Grid container spacing={2}>
            <Grid item xs={12} className="heading">
              <Typography className="document_head" variant="h5">
                Emirate Id
              </Typography>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="control_group">
                <Typography className="custom_label"> Emirate Id</Typography>
                <TextField
                  hiddenLabel
                  type={"text"}
                  name="ORN"
                  className="text_field"
                  variant="outlined"
                  fullWidth
                  placeholder="Enter emirate id"
                  value={documents.documentNumber_17}
                  onChange={(e) => {
                    if (e.target.value === " ") {
                    } else {
                      setDocuments({
                        ...documents,
                        documentNumber_17: e.target.value,
                      });
                    }
                  }}
                />
              </div>
              <div className="control_group">
                <Typography className="custom_label">Expiry date</Typography>
                <TextField
                  hiddenLabel
                  type={"date"}
                  className="text_field"
                  variant="outlined"
                  fullWidth
                  placeholder="Enter expiry date"
                  value={documents.expiryDate_17}
                  inputProps={{ min: new Date().toISOString().split("T")[0] }}
                  onChange={(e) => {
                    setDocuments({
                      ...documents,
                      expiryDate_17: e.target.value,
                    });
                  }}
                />
              </div>
            </Grid>

            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="control_group">
                <Typography className="custom_label">Front Image</Typography>
                <Box className="docs_div v2">
                  {documents.frontImage_17 ? (
                    <>
                      <figure
                        onClick={() => {
                          window.open(documents.frontImage_17);
                        }}
                      >
                        <img
                          src={
                            documents.frontImage_17
                              ? "/static/images/pdf.png"
                              : "/static/images/upload.png"
                          }
                          alt=""
                        />
                      </figure>
                      <span
                        onClick={() =>
                          setDocuments({ ...documents, frontImage_17: "" })
                        }
                        className="clear_icon"
                      >
                        <ClearIcon />
                      </span>
                    </>
                  ) : (
                    <figure>
                      <img
                        src={
                          documents.frontImage_17
                            ? "/static/images/pdf.png"
                            : "/static/images/upload.png"
                        }
                        alt=""
                      />
                      <input
                        type="file"
                        id="upload-front-image"
                        style={{ display: "none" }}
                        accept="application/pdf"
                        onChange={(event) =>
                          handlePdfUpload(event, "frontImage_17")
                        }
                      />
                    </figure>
                  )}
                </Box>
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <div className="control_group">
                <Typography className="custom_label">Back Image</Typography>
                <Box className="docs_div v2">
                  {documents.backImage_17 ? (
                    <>
                      <figure
                        onClick={() => {
                          window.open(documents.backImage_17);
                        }}
                      >
                        <img
                          src={
                            documents.backImage_17
                              ? "/static/images/pdf.png"
                              : "/static/images/upload.png"
                          }
                          alt=""
                        />
                      </figure>
                      <span
                        onClick={() =>
                          setDocuments({ ...documents, backImage_17: "" })
                        }
                        className="clear_icon"
                      >
                        <ClearIcon />
                      </span>
                    </>
                  ) : (
                    <figure>
                      <img
                        src={
                          documents.backImage_17
                            ? "/static/images/pdf.png"
                            : "/static/images/upload.png"
                        }
                        alt=""
                      />
                      <input
                        type="file"
                        id="upload-front-image"
                        style={{ display: "none" }}
                        accept="application/pdf"
                        onChange={(event) =>
                          handlePdfUpload(event, "backImage_17")
                        }
                      />
                    </figure>
                  )}
                </Box>
              </div>
            </Grid>
          </Grid>
        </div>

        {documents.agentEmirate == AGENT_EMIRATE.DUBAI_BASED ? (
          <div className="single_doc">
            <Grid container spacing={2}>
              <Grid item xs={12} className="heading">
                <Typography className="document_head" variant="h5">
                  BRN
                </Typography>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <div className="control_group">
                  <Typography className="custom_label">BRN</Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="ORN"
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    placeholder="Enter BRN"
                    value={documents.BRN}
                    onChange={(e) => {
                      if (e.target.value === " ") {
                      } else {
                        setDocuments({ ...documents, BRN: e.target.value });
                      }
                    }}
                  />
                </div>
                <div className="control_group">
                  <Typography className="custom_label">Expiry date</Typography>
                  <TextField
                    hiddenLabel
                    type={"date"}
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    placeholder="Enter expiry date"
                    value={documents.brn_expiryDate}
                    onChange={(e) => {
                      setDocuments({
                        ...documents,
                        brn_expiryDate: e.target.value,
                      });
                    }}
                  />
                </div>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <div className="control_group">
                  <Typography className="custom_label">
                    BRN Certificate
                  </Typography>
                  <Box className="docs_div v2">
                    {documents.brn_certificate ? (
                      <>
                        <figure
                          onClick={() => {
                            window.open(documents.brn_certificate);
                          }}
                        >
                          <img
                            src={
                              documents.brn_certificate
                                ? "/static/images/pdf.png"
                                : "/static/images/upload.png"
                            }
                            alt=""
                          />
                        </figure>
                        <span
                          onClick={() =>
                            setDocuments({ ...documents, brn_certificate: "" })
                          }
                          className="clear_icon"
                        >
                          <ClearIcon />
                        </span>
                      </>
                    ) : (
                      <figure>
                        <img
                          src={
                            documents.brn_certificate
                              ? "/static/images/pdf.png"
                              : "/static/images/upload.png"
                          }
                          alt=""
                        />
                        <input
                          type="file"
                          id="upload-front-image"
                          style={{ display: "none" }}
                          accept="application/pdf"
                          onChange={(event) =>
                            handlePdfUpload(event, "brn_certificate")
                          }
                        />
                      </figure>
                    )}
                  </Box>
                </div>
              </Grid>
            </Grid>
          </div>
        ) : (
          ""
        )}

        {/* {documents.agentEmirate == AGENT_EMIRATE.ABU_DHABI ? (
                    <div className="single_doc">
                        <Grid container spacing={2}>

                            <Grid item xs={12} className="heading">
                                <Typography className="document_head" variant="h5">
                                    Adrec Broker card
                                </Typography>
                            </Grid>
                            <Grid item lg={4} md={4} sm={6} xs={12}>
                                <div className="control_group">
                                    <Typography className="custom_label"> Adrec Broker card Number</Typography>
                                    <TextField
                                        hiddenLabel
                                        type={"text"}
                                        className="text_field"
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Enter card number"
                                        value={documents.documentNumber_19}
                                        onChange={(e) => {
                                            if (
                                                e.target.value === " "

                                            ) {
                                            } else {
                                                setDocuments({ ...documents, documentNumber_19: e.target.value })
                                            }
                                        }}


                                    />
                                </div>
                            </Grid>

                            <Grid item lg={4} md={4} sm={6} xs={12}>
                                <div className="control_group">
                                    <Typography className="custom_label">Adrec Broker card </Typography>
                                    <Box className="docs_div v2">
                                        {documents.frontImage_19 ? (
                                            <>
                                                <figure
                                                    onClick={() => {
                                                        window.open(documents.frontImage_19);
                                                    }}
                                                >
                                                    <img
                                                        src={
                                                            documents.frontImage_19
                                                                ? "/static/images/pdf.png"
                                                                : "/static/images/upload.png"
                                                        }
                                                        alt=""
                                                    />
                                                </figure>
                                                <span
                                                    onClick={() => setDocuments({ ...documents, frontImage_19: "" })}
                                                    className="clear_icon"
                                                >
                                                    <ClearIcon />
                                                </span>
                                            </>
                                        ) : (
                                            <figure>
                                                <img
                                                    src={
                                                        documents.frontImage_19
                                                            ? "/static/images/pdf.png"
                                                            : "/static/images/upload.png"
                                                    }
                                                    alt=""
                                                />
                                                <input
                                                    type="file"
                                                    id="upload-front-image"
                                                    style={{ display: "none" }}
                                                    accept="application/pdf"
                                                    onChange={(event) =>
                                                        handlePdfUpload(event, "frontImage_19")
                                                    }
                                                />
                                            </figure>
                                        )}
                                    </Box>

                                </div>
                            </Grid>

                        </Grid>
                    </div>
                ) : ("")} */}

        {documents.agentEmirate == AGENT_EMIRATE.OTHERS ? (
          <div className="single_doc">
            <Grid container spacing={2}>
              <Grid item xs={12} className="heading">
                <Typography className="document_head" variant="h5">
                  Labour or Employment Visa documents
                </Typography>
              </Grid>
              <Grid item lg={4} md={4} sm={6} xs={12}>
                <div className="control_group">
                  <Typography className="custom_label">
                    {" "}
                    Document Number
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    placeholder="Enter document number"
                    value={documents.documentNumber_20}
                    onChange={(e) => {
                      if (e.target.value === " ") {
                      } else {
                        setDocuments({
                          ...documents,
                          documentNumber_20: e.target.value,
                        });
                      }
                    }}
                  />
                </div>
              </Grid>

              <Grid item lg={4} md={4} sm={6} xs={12}>
                <div className="control_group">
                  <Typography className="custom_label">
                    Adrec Broker card{" "}
                  </Typography>
                  <Box className="docs_div v2">
                    {documents.frontImage_20 ? (
                      <>
                        <figure
                          onClick={() => {
                            window.open(documents.frontImage_20);
                          }}
                        >
                          <img
                            src={
                              documents.frontImage_20
                                ? "/static/images/pdf.png"
                                : "/static/images/upload.png"
                            }
                            alt=""
                          />
                        </figure>
                        <span
                          onClick={() =>
                            setDocuments({ ...documents, frontImage_20: "" })
                          }
                          className="clear_icon"
                        >
                          <ClearIcon />
                        </span>
                      </>
                    ) : (
                      <figure>
                        <img
                          src={
                            documents.frontImage_20
                              ? "/static/images/pdf.png"
                              : "/static/images/upload.png"
                          }
                          alt=""
                        />
                        <input
                          type="file"
                          id="upload-front-image"
                          style={{ display: "none" }}
                          accept="application/pdf"
                          onChange={(event) =>
                            handlePdfUpload(event, "frontImage_20")
                          }
                        />
                      </figure>
                    )}
                  </Box>
                </div>
              </Grid>
            </Grid>
          </div>
        ) : (
          ""
        )}

        <div className="form_btn">
          <Button
            size="large"
            onClick={() => uploadDocumentsFun()}
            type="submit"
            className="btn btn_primary"
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AgentDocumentation;
